import { Injectable } from '@angular/core';
import {ConfiguracionGeneralResource} from './configuracion-general.resource';
import {ConfiguracionGeneralModel} from './configuracion-general.model';
import {ConfiguracionTarjetaModel} from '../../admin.configuracion-tarjeta.module/service/configuracion-tarjeta.model';
import { ConfiguracionTarjetaTpvModel } from '../../admin.configuracion-tarjeta.module/service/configuracion-tarjeta-tpv.model';

@Injectable({
  providedIn: 'root'
})
export class ConfiguracionGeneralService {

  constructor(private configuracionGeneralResource: ConfiguracionGeneralResource) { }

  obtenerConfiguracionGeneral(): Promise<ConfiguracionGeneralModel> {
    return this.configuracionGeneralResource.obtenerConfiguracionGeneral();
  }

  actualizarConfiguracionGeneral(configuracion: ConfiguracionGeneralModel): Promise<any> {
    return this.configuracionGeneralResource.actualizarConfiguracionGeneral(configuracion);
  }

  obtenerConfiguracionTarjetaTia(): Promise<ConfiguracionTarjetaModel> {
    return this.configuracionGeneralResource.obtenerConfiguracionTarjetaTia();
  }

  obtenerConfiguracionTarjetaTpv(): Promise<ConfiguracionTarjetaTpvModel>{
    return this.configuracionGeneralResource.obtenerConfiguracionTarjetaTpv();
  }
}

